<template>
  <div class="tw:flex tw:items-center tw:gap-3 tw:md:gap-6 tw:text-left">
    <div class="flag tw:w-[28px] tw:h-[17px] flagImage" :class="`flag-${marketCode.toLowerCase()}`" />
    <div>
      <strong class="tw:text-gray-700">{{ marketName }}</strong>
      <p class="tw:text-sm tw:text-gray-700">{{ domain }}</p>
    </div>
  </div>
</template>
<script setup>
defineProps({
  marketName: String,
  domain: String,
  marketCode: String,
})
</script>
<style scoped>
.flag {
  left: 1.6rem;
  background-size: 28px auto;
  top: 1.6rem;
  background-position: 0 0;
}
.flagImage {
  background-image: url(https://imgcy.trivago.com/q_auto/v1/hardcodedimages/imagemap_all_flags_21@2x.png);

  background-repeat: no-repeat;
}
.flag-at {
  background-position: 0 -1134px;
}
.flag-de {
  background-position: 0 1px;
}
.flag-en,
.flag-uk {
  background-position: 0 -41px;
}
.flag-es {
  background-position: 0 -84px;
}
.flag-fr {
  background-position: 0 -126px;
}
.flag-se {
  background-position: 0 -168px;
}
.flag-pl {
  background-position: 0 -210px;
}
.flag-ru {
  background-position: 0 -252px;
}
.flag-it {
  background-position: 0 -294px;
}
.flag-gr {
  background-position: 0 -336px;
}
.flag-nl {
  background-position: 0 -377px;
}
.flag-rs {
  background-position: 0 -420px;
}
.flag-tr {
  background-position: 0 -462px;
}
.flag-ro {
  background-position: 0 -504px;
}
.flag-ar {
  background-position: 0 -546px;
}
.flag-ie {
  background-position: 0 -1218px;
}
.flag-id {
  background-position: 0 -1806px;
}
.flag-hu {
  background-position: 0 -1260px;
}
.flag-br {
  background-position: 0 -630px;
}
.flag-zh,
.flag-cn {
  background-position: 0 -672px;
}
.flag-us {
  background-position: 0 -713px;
}
.flag-fi {
  background-position: 0 -756px;
}
.flag-jp {
  background-position: 0 -818px;
}
.flag-mx {
  background-position: 0 -840px;
}
.flag-pt {
  background-position: 0 -882px;
}
.flag-cs,
.flag-cz {
  background-position: 0 -1178px;
}
.flag-bg {
  background-position: 0 -588px;
}
.flag-da,
.flag-dk {
  background-position: 0 -966px;
}
.flag-no {
  background-position: 0 -1008px;
}
.flag-be {
  background-position: 0 -1050px;
}
.flag-so,
.flag-si {
  background-position: 0 -1092px;
}
.flag-ch {
  background-position: 0 -1302px;
}
.flag-ca {
  background-position: 0 -1386px;
}
.flag-nz {
  background-position: 0 -1470px;
}
.flag-au {
  background-position: 0 -1344px;
}
.flag-co {
  background-position: 0 -1680px;
}
.flag-ko,
.flag-kr {
  background-position: 0 -1428px;
}
.flag-cl {
  background-position: 0 -1638px;
}
.flag-sg {
  background-position: 0 -1596px;
}
.flag-in {
  background-position: 0 -924px;
}
.flag-hk {
  background-position: 0 -1554px;
}
.flag-ae {
  background-position: 0 -1848px;
}
.flag-ms,
.flag-my {
  background-position: 0 -1722px;
}
.flag-th {
  background-position: 0 -1764px;
}
.flag-he,
.flag-il {
  background-position: 0 -1890px;
}
.flag-za {
  background-position: 0 -1932px;
}
.flag-tw {
  background-position: 0 -1974px;
}
.flag-ph {
  background-position: 0 -2058px;
}
.flag-world_wide {
  background-position: 0 -2100px;
}
.flag-vn {
  background-position: 0 -2016px;
}

.flag-aa,
.flag-shabaka {
  background-position: 0 -2142px;
}
.flag-hr {
  background-position: 0 -2184px;
}
.flag-sk {
  background-position: 0 -2226px;
}
.flag-pe {
  background-position: 0 -2268px;
}
.flag-ec {
  background-position: 0 -2310px;
}
.flag-uy {
  background-position: 0 -2352px;
}
.flag-ng {
  background-position: 0 -2394px;
}
</style>
